import React from "react";
import { compose, branch } from "recompose";
import AvailableStoreQuery from "./AvailableStoreQuery.gql";
import EnhanceStoreViewSelector from "./EnhanceStoreViewSelector";
import StoreViewUrlQuery from "./StoreViewUrlQuery.gql";
import getShopName from "./getShopName";
import { defineMessages, useIntl } from "react-intl";
import Selector from "theme/components/molecules/Selector";

const messages = defineMessages({
  title: {
    id: "modules.User.StoreViewSelector.title",
    defaultMessage: "Change language",
  },
});

const StoreViewSelector = (props) => {
  const intl = useIntl();
  return (
    <Selector
      options={props.data.availableStores.map((id) => ({
        value: id,
        label: getShopName(id),
      }))}
      title={intl.formatMessage(messages.title)}
      current={getShopName(props.data.shop.id)}
      value={props.data.shop.id}
      onSelect={props.setStoreView}
    />
  );
};

export default compose(
  EnhanceStoreViewSelector({ AvailableStoreQuery, StoreViewUrlQuery }),
  branch(
    (props) => props.data.loading,
    () => () => null,
    (BaseComponent) => BaseComponent
  )
)(StoreViewSelector);
